<div class="tooltip-container">
  <mat-icon class="info-icon-component">help_outline</mat-icon>
  <span *ngIf="tip" class="tip klabel-small" [innerHTML]="tip"></span>
</div>